module.exports = __webpack_public_path__ + "img/bg-story-thumbnail.bd55507a.png";